import { useQuery } from '@apollo/client';

import { PATIENT_APPOINTMENTS } from 'kb-shared/graphql/queries';
import { BugTracker } from 'kb-shared/utilities/bugTracker';

import {
  CRYO_FUTURE_REGISTRATION_LINK,
  CRYO_INVENTORY_OWNED,
  MY_JOURNEY_QUERY
} from './Dashboard.graphql';
import {
  CryoFutureRegistrationLinkResponse,
  CryoInventoryOwnedResponse,
  JourneyResponse,
  PatientAppointments
} from './Dashboard.types';

export const usePatientAppointments = () => {
  const { data, loading, refetch } = useQuery<PatientAppointments>(PATIENT_APPOINTMENTS, {
    onError: error => BugTracker.notify(error, 'PatientAppointmentsFetch')
  });

  return { data, loading, refetch };
};

export const useMyJourney = () => {
  const { data, loading } = useQuery<JourneyResponse>(MY_JOURNEY_QUERY, {
    onError: error => BugTracker.notify(error, 'PatientJourneyFetch')
  });

  return { data, loading };
};

export const useCryoFuture = () => {
  const { data, loading } = useQuery<CryoInventoryOwnedResponse>(CRYO_INVENTORY_OWNED, {
    onError: error => BugTracker.notify(error, 'PatientCryoInventoryOwnedFetch')
  });

  return { data, loading };
};

export const useCryoFutureRedirectLink = () => {
  const { data, loading } = useQuery<CryoFutureRegistrationLinkResponse>(
    CRYO_FUTURE_REGISTRATION_LINK,
    {
      onError: error => BugTracker.notify(error, 'PatientCryoFutureRegistrationLinkFetch')
    }
  );

  return { data, loading };
};
